// extracted by mini-css-extract-plugin
module.exports = {"content":"Support_content__bmwTa"};